import type { SVGProps } from "react";

/**
 * Remix: take someone else's thing and send it back out as ours.
 *
 * The repost cycle is the right idea — two arrows, the thing going round again
 * and coming back changed. The execution is not Instagram's. Theirs is a soft
 * rounded loop; this system is angular and sharp, so the same circuit is drawn
 * with mitred corners and square caps, and the two runs are deliberately
 * OFFSET rather than mirrored: it comes back on a different line from the one
 * it left on, because a remix is not a repost. Nothing is returned unchanged.
 *
 * Replaces the sparkle that Recreate shared with M7 Agents.
 */
export default function RemixMark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="square"
      strokeLinejoin="miter"
      {...props}
    >
      {/* out along the top, turning down the right */}
      <path d="M4 8h13l-3.2-3.2M17 8v4" />
      {/* back along the bottom, turning up the left */}
      <path d="M20 16H7l3.2 3.2M7 16v-4" />
    </svg>
  );
}
